export const REJECTED_COLLAPSED = [
  'Declined offer',
  "Don't have required skills",
  'Another candidate was hired',
  'Opening was closed',
  'Other',
  'Other ', // Space added due to structure
  'High money motivation',
  'Lack of skills / experience',
  'No / bad English',
  'Location / Relocation',
  'Stay at current company',
  'Another Company’s JO accepted',
  'Without explanation',
  'Didn’t show up to interview',
  'Personal reasons',
  'Refused to do a test task',
  'Bad recommendations',
  'Low technical level',
  'Junior level specialist',
  'No soft skills',
  'Low salary offered',
  'Project (interested in other Company’s project)',
  'Didn’t show up',
  'Blacklisted candidate',
  'Stopped replying',
] as const;

export const REJECTED_CANDIDATE_COLLAPSED = [
  'Stay at current company',
  'Another Company’s JO accepted',
  'Without explanation',
  'Didn’t show up to interview',
  'Personal reasons',
  'Refused to do a test task',
  'Other ', // Space added due to structure
] as const;

export const REJECTED_TEAM_LEAD_COLLAPSED = [
  'Bad recommendations',
  'Low technical level',
  'High money motivation',
  'Junior level specialist',
  'No soft skills',
  'No / bad English',
  'Other',
  'Blacklisted candidate',
] as const;

export const COLLAPSED_BY_NAME: Record<string, readonly string[]> = {
  Rejected: REJECTED_COLLAPSED,
  'Rejected by candidate': REJECTED_CANDIDATE_COLLAPSED,
  'Rejected by management': REJECTED_TEAM_LEAD_COLLAPSED,
  'Rejected by Team Lead': REJECTED_TEAM_LEAD_COLLAPSED,
};

export const HIDE_PERCENTAGE = ['Left from the previous period', 'During the period'];

export const COLUMNS = [
  {
    title: 'Month/Transition',
    dataIndex: 'name',
    key: 'name',
    fixed: 'left' as const,
    width: 320,
  },
];

export const SECTION_URLS = [
  'hiring-statistics/contact-with-candidate',
  'hiring-statistics/cv-screening',
  'hiring-statistics/technical-interviews-scheduled',
  'hiring-statistics/technical-interviews-conducted',
  'hiring-statistics/management-interviews-conducted',
  'hiring-statistics/management-approval',
  'hiring-statistics/job-offers',
  'hiring-statistics/onboarding',
  'hiring-statistics/hired',
] as const;
